export default __webpack_public_path__ + "static/media/f-one-go@3x.bf68eb33.png";